import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { authorizationCode } from "./schema/oauth/authorizationCode";
import { getLinkedMerchantPhone } from "./schema/person/get-linked-merchant-phone";
import { setMarketingSmsConsent } from "./schema/person/set-marketing-sms-consent";
import { setOperationalSmsConsent } from "./schema/person/set-operational-sms-consent";
import { startLinkMerchantPhone } from "./schema/person/start-link-merchant-phone";
import { unlinkMerchantPhone } from "./schema/person/unlink-merchant-phone";
import { verifyLinkMerchantPhone } from "./schema/person/verify-link-merchant-phone";

const merchantPersonPhone = {
  getLinkedMerchantPhone,
  setMarketingSmsConsent,
  setOperationalSmsConsent,
  startLinkMerchantPhone,
  unlinkMerchantPhone,
  verifyLinkMerchantPhone,
};

export const rpcDefinition = { authorizationCode, ...merchantPersonPhone };

export type RedoAuthRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
